// Centralized catalog of predefined categories and hashtags
// Update this list to change what's available across the app

export const TAG_CATALOG = [
  {
    id: "stripe-webhooks-events",
    label: "Stripe Webhooks & Event Delivery",
    tags: [
      "#WebhookFail",
      "#SignatureVerification",
      "#EventDelivery",
      "#EndpointTimeout",
      "#WebhookRetries",
      "#Idempotency",
      "#EventOrdering",
      "#StripeCLI",
      "#LiveMode",
      "#TestMode",
    ],
  },
  {
    id: "subscriptions-billing-logic",
    label: "Subscriptions & Billing Logic",
    tags: [
      "#SubscriptionSync",
      "#InvoiceMismatch",
      "#Proration",
      "#PlanUpgrade",
      "#PlanDowngrade",
      "#BillingCycle",
      "#RetryLogic",
      "#Dunning",
      "#InvoiceFinalization",
      "#CouponDiscounts",
    ],
  },
  {
    id: "checkout-payments-access",
    label: "Checkout, Payments & Access Sync",
    tags: [
      "#CheckoutFail",
      "#PaymentIntent",
      "#SCA3DS",
      "#CardDecline",
      "#PaymentSucceededNoAccess",
      "#EntitlementSync",
      "#AuthPaymentSync",
      "#CustomerChargedTwice",
      "#RefundIssue",
      "#TaxCalculation",
    ],
  },
  {
    id: "connect-payouts-reliability",
    label: "Connect, Payouts & Reliability",
    tags: [
      "#StripeConnect",
      "#AccountLinking",
      "#TransferFail",
      "#PayoutDelay",
      "#OnboardingIncomplete",
      "#KYCVerification",
      "#BalanceTransaction",
      "#ProductionOutage",
      "#IncidentResponse",
      "#PaymentReliability",
    ],
  },
];

export const ALL_PREDEFINED_TAGS = TAG_CATALOG.flatMap((c) => c.tags);

// Normalize helper/problem tags to a canonical lowercase form without leading '#'
export const normalizePredefinedTag = (t) =>
  String(t).replace(/^#/, "").toLowerCase();


